// Language Mapping for files, and Prism highlighting 
export const FILE_EXTENSION_MAP = {
    'C++': 'cpp',
    'Go': 'go',
    'Java': 'java',
    'Javascript': 'js',
    'Kotlin': 'kt',
    'Python': 'py',
    'SQL': 'sql',
    'Swift': 'swift',
    'Typescript': 'ts'
};
export const PRISM_LANGUAGE_MAP = {
    'C++': 'cpp',
    'Go': 'go',
    'Java': 'java',
    'Javascript': 'javascript',
    'Kotlin': 'kotlin',
    'Python': 'python',
    'SQL': 'sql',
    'Swift': 'swift',
    'Typescript': 'typescript'
};

// Columns Keys for sorting
export const SORT_COLUMN_KEYS = [
    'problemName',
    'problemId'
];

// Website Paths for problems on LeetCode, Open-Kattis
export const LEET_CODE_WEBSITE_LINK = "https://leetcode.com/problems/";     // problem names need to be lowercase and replace " " with '-'
export const OPEN_KATTIS_WEBSITE_LINK = "https://open.kattis.com/problems/";// problem names need to be the corresponding problem id

// GitHub variables
export const OWNER = process.env.REACT_APP_OWNER;
export const LEET_CODE_REPO = process.env.REACT_APP_LEET_CODE_REPO;
export const LEET_CODE_SOLUTION_PATH = "https://github.com/neroAzsy12/LeetCode/blob/main/";
export const OPEN_KATTIS_REPO = process.env.REACT_APP_OPEN_KATTIS_REPO;
export const OPEN_KATTIS_SOLUTION_PATH = "https://github.com/neroAzsy12/Open-Kattis/blob/main/";
export const REPO_MD_FILE = process.env.REACT_APP_MD_FILE;

// Utility Functions
export function formatLeetCodeData(fileContent) {
    const results = [];
    const dataTableArray = fileContent.split(/\n/g);
    for (let index = 2; index < dataTableArray.length - 1; index++) {
        const dataRow = dataTableArray[index].split('|');

        const problemData = {
            problemId: Number(dataRow[0]),  // number
            problemName: dataRow[1],        // string
            difficulty: dataRow[2],         // string
            timeComplexity: dataRow[3],     // string
            languages: dataRow[4].split(',')// string[]
        };
        results.push(problemData);
    }
    return results;
}

export function formatOpenKattisData(fileContent) {
    const results = [];
    const dataTableArray = fileContent.split(/\n/g);
    for (let index = 2; index < dataTableArray.length - 1; index++) {
        const dataRow = dataTableArray[index].split('|');

        const problemData = {
            problemName: dataRow[0],        // string
            problemId: dataRow[1],          // string
            difficulty: dataRow[2],         // string
            languages: dataRow[3].split(',')// [string]
        };

        results.push(problemData);
    }
    return results;
}